import Popup from '@Components/Popups/Popup'
import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'
import React, { JSX } from 'react'

interface UploadDocumentConfirmationPopupProps {
    confirmationPopupTitle: string
    confirmationPopupBody: JSX.Element
    onClose: () => void
    onConfirm: () => void
    isDisabled: boolean
}

const UploadDocumentConfirmationPopup = (props: UploadDocumentConfirmationPopupProps) => {
    const { confirmationPopupTitle, confirmationPopupBody, onClose, onConfirm, isDisabled } = props

    return (
        <Popup onClose={onClose}>
            <ConfirmationPopup
                title={confirmationPopupTitle}
                onCancel={onClose}
                cancelButtonText="Cancel"
                disabled={isDisabled}
                onConfirm={onConfirm}
                confirmButtonText="Confirm"
            >
                {confirmationPopupBody}
            </ConfirmationPopup>
        </Popup>
    )
}
export default UploadDocumentConfirmationPopup
